import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Observable } from 'rxjs';
import { AppConfigQuery } from '../../core/state/app-config/app-config.query';
import { SbHost } from '../../legacy/model';

export function createSbTranslateLoader(http: HttpClient): TranslateHttpLoader {
    return new TranslateHttpLoader(http, 'translation/', '.json');
}

export class SbTranslateLoader implements TranslateLoader {
    constructor(private http: HttpClient, private appConfig: AppConfigQuery) {}

    getTranslation(language: string): Observable<any> {
        /*const baseUrl = this.appConfig.getBaseUrlFromHost(
            SbHost.LayoutConfigurationBaseUrl
        );
        let url = baseUrl + '/' + 'translation';*/
        // load translations from assets instead of backend to allow translations to be loaded even without token (we still need to deploy the translations to the backend with existing setup so no use in loading from backend)
        const url = `./assets/i18n/${language}`;
        return this.http.get(url);
    }
}
